var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-343.4625 -532.5 2976.675 3195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1437.75 1011.75L532.5 852v1180.393c0 53.907 43.7 97.607 97.607 97.607h1562.036c53.907 0 97.607-43.7 97.607-97.607V1597.5z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.75 0H630.107C576.2 0 532.5 43.7 532.5 97.607V532.5l905.25 532.5L1917 1224.75 2289.75 1065V532.5z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5 532.5h905.25V1065H532.5z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.393 426H532.5v1331.25h647.893c53.834-.175 97.432-43.773 97.607-97.607V523.607c-.175-53.834-43.773-97.432-97.607-97.607z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.143 479.25H532.5V1810.5h594.643c53.834-.175 97.432-43.773 97.607-97.607V576.857c-.175-53.834-43.773-97.432-97.607-97.607z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.143 479.25H532.5V1704h594.643c53.834-.175 97.432-43.773 97.607-97.607V576.857c-.175-53.834-43.773-97.432-97.607-97.607z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.893 479.25H532.5V1704h541.393c53.834-.175 97.432-43.773 97.607-97.607V576.857c-.175-53.834-43.773-97.432-97.607-97.607z",
    opacity: 0.2
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 2132)",
    y2: 404.982,
    x2: 967.987,
    y1: 1729.018,
    x1: 203.513,
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.607 479.25h976.285c53.907 0 97.607 43.7 97.607 97.607v976.285c0 53.907-43.7 97.607-97.607 97.607H97.607C43.7 1650.75 0 1607.05 0 1553.143V576.857c0-53.907 43.7-97.607 97.607-97.607z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.3 1382.264l205.332-318.169L319.5 747.683h151.336l102.666 202.35c9.479 19.223 15.975 33.494 19.49 42.919h1.331a798.667 798.667 0 0121.3-44.677L725.371 747.79H864.3l-192.925 314.548L869.2 1382.263H721.378L602.79 1160.158a186.298 186.298 0 01-14.164-29.66h-1.757a140.458 140.458 0 01-13.739 28.755l-122.102 223.011z",
    fill: "#FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2192.143 0H1437.75v532.5h852V97.607C2289.75 43.7 2246.05 0 2192.143 0z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.75 1065h852v532.5h-852z",
    fill: "#107C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.a79c9c14f22276a716d361ab1d44a55b.svg";
export { ForwardRef as ReactComponent };